import styled from 'styled-components';

export const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.palette.neutral.surface1};
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.1;
  z-index: 10;
`;
